<template>
    <div style="margin-top: 10px;font-size: 16px;">
        <el-form :model="work" :rules="rules" ref="work">
      <div class="basicInfo">
        <div class="title">车辆&客户信息</div>
        <div style="margin-top: 10px;font-size: 12px;">
            <el-row style="margin-top: 10px">
                <el-col :span="12" class="basic-column">
                    <el-form-item label="车牌" prop="carNo" label-width="70px">
                        <el-input class="inputEl" v-model="work.carNo" onchange="value=value.toUpperCase()" @change="changeCarNo" />
                    </el-form-item>
                    <el-form-item label="车主姓名" label-width="70px">
                        <el-input class="inputEl" v-model="work.ownerName" />
                    </el-form-item>
                    <el-form-item label="颜色" label-width="70px">
                        <color-select v-model="work.color" style="width:100px;height:20px;"></color-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="basic-column">
                    <el-form-item label="品牌/车系" label-width="70px">
                        <div style="width: 98px;height: 18px;border-radius: 5px;border: 1px solid #DCDFE6;margin-top: 5px;line-height: 20px;padding:0 5px;"
                        disabled @click="carPanel=!carPanel">
                            <span v-if="brand.length>0">{{brandNameMap[brand[0]]}}/{{brand[1]}}</span>
                            <span v-else>{{brandNameMap[work.brandModel[0]]}} / {{work.brandModel[1]}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="70px">
                        <el-input class="inputEl" v-model="work.phone" @change="changeOwnerCellphone"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
      </div>
      <div class="basicInfo" style="margin-top: 10px;">
        <div class="title">工单信息</div>
        <div style="margin-top: 10px;font-size: 12px;">
            <el-row style="margin-top: 10px">
                <el-col :span="12" class="basic-column">
                    <el-form-item label="工单号" label-width="70px">
                        <el-input class="inputEl" v-model="work.extraId" />
                    </el-form-item>
                    <el-form-item label="服务顾问" :prop="isConsultant? '' : 'consultantId'" label-width="70px">
                        <div v-if="isConsultant" style="margin-top:6px;">{{$store.state.user.name}}</div>
                        <div v-else style="margin-top:6px;">
                            <van-dropdown-menu active-color="#329DFF">
                                <van-dropdown-item v-model="work.consultantId" :options="option3" />
                            </van-dropdown-menu>
                        </div>
                    </el-form-item>
                    <el-form-item label="进厂时间" label-width="70px">
                        <div style="width: 106px;">{{work.enterTime ? work.enterTime.format('yyyy-MM-dd hh:mm') : ''}}</div>
                    </el-form-item>
                    <el-form-item label="维修时间" label-width="70px">
                        <div style="width: 106px;text-align: center;">{{ repairDays }}天</div>
                    </el-form-item>
                    <el-form-item label="是否外返" label-width="70px">
                        <div style="margin-top:6px;">
                            <van-radio-group v-model="work.isOutsideRework" direction="horizontal">
                                <van-radio :name="1">是</van-radio>
                                <van-radio :name="0">否</van-radio>
                            </van-radio-group>
                    </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="basic-column">
                    <el-form-item label="付款方式" label-width="70px">
                        <div style="margin-top:6px;">
                            <van-dropdown-menu active-color="#329DFF">
                                <van-dropdown-item v-model="work.payMethodCode" :options="option1" />
                            </van-dropdown-menu>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="isInsurancePay" label="保险公司" :prop="isInsurancePay ? 'insuranceCompanyId' :''" label-width="70px">
                        <div style="margin-top:6px;">
                            <van-dropdown-menu active-color="#329DFF">
                                <van-dropdown-item v-model="work.insuranceCompanyId" :options="option2" />
                            </van-dropdown-menu>
                        </div>
                    </el-form-item>
                    <el-form-item v-else label="保险公司" label-width="70px">
                        <div style="margin-top:6px;">
                            <van-dropdown-menu active-color="#329DFF">
                                <van-dropdown-item disabled v-model="work.insuranceCompanyId" :options="option2" />
                            </van-dropdown-menu>
                        </div>
                    </el-form-item>
                    <el-form-item label="交车时间" prop="estimateDeliveryTime" label-width="70px">
                        <div style="margin-top:6px;">
                            <div style="width:108px;height:18px;line-height:18px;border-radius:5px;border:1px solid #DCDFE6;" @click="openDateTimePicker">{{ editEstimateDeliveryTime }}</div>
                            <van-popup v-model="showDateTimePicker" position="bottom" style=" height: 60%">
                                <van-datetime-picker
                                v-model="editEstimateDeliveryTime"
                                 type="datetime"
                                 title="选择交车时间"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="confirm"
                                @cancel="cancel">
                                </van-datetime-picker>
                            </van-popup>
                        </div>
                    </el-form-item>
                    <el-form-item label="是否加急" label-width="70px">
                        <div style="margin-top:6px;">
                            <van-radio-group v-model="work.urgent" direction="horizontal">
                                <van-radio :name="true">是</van-radio>
                                <van-radio :name="false">否</van-radio>
                            </van-radio-group>
                        </div>
                    </el-form-item>
                    <el-form-item label="外返原因" label-width="70px" v-if="work.isOutsideRework===1" prop="outsideReworkReasonId">
                        <div style="margin-top:6px;">
                            <van-dropdown-menu active-color="#329DFF">
                                <van-dropdown-item v-model="work.outsideReworkReasonId" :options="option4" />
                            </van-dropdown-menu>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
      </div>
      <div class="basicInfo" style="margin-top: 10px;">
        <div class="title">备注</div>
        <div style="text-align: center;"><textarea v-model="work.remarks" style="width: 90%;height: 100px;resize: none;margin-top: 10px;border-radius: 10px;"></textarea></div>
      </div>
    </el-form>
      <van-popup v-model="carPanel" style="width: 100%; height: 100%">
        <wx-carselect-panel :show.sync="carPanel" :brand="brand" :workCop="workCop"></wx-carselect-panel>
      </van-popup>
    </div>
  </template>

  <script>
    import WxCarselectPanel from '@/views/wx/WxCarselectPanel'
    import { shareDataMixin } from '@/views/mixins/ShareData'
    import { Popup, DropdownMenu, DropdownItem, DatetimePicker, RadioGroup, Radio } from 'vant'
    import { checkHasPosition } from '@/utils/auth-directive'
    import { customerByCarNo, customerByCellphone } from '@/utils/request'
    import { isCarNo } from '@/utils/validate'
    import ColorSelect from '@/components/selector/ColorSelect'

    export default {
      name: 'WxWorkBasicinfoPanel',
      components: {
        WxCarselectPanel,
        ColorSelect,
        [Popup.name]: Popup,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [DatetimePicker.name]: DatetimePicker,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio
      },
      mixins: [shareDataMixin],
      props: {
        work: {
          type: Object,
          required: true
        },
        brand: {
          type: Array,
          required: true
        }
      },
      data () {
        return {
            rules: {
          carNo: [
            {
              required: true,
              trigger: 'change',
              validator (rule, value, callback) {
                if (rule.required) {
                    if (!isCarNo(value.replace(/\s*/g, ''))) {
                        callback(new Error('请输入正确车牌号'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
              }
            }
          ],
          brandModel: [
            {
              required: true,
              message: '请输入品牌/型号',
              trigger: 'change'
            }
          ],
          color: [
            {
              required: true,
              message: '请输入颜色',
              trigger: 'change'
            }
          ],
          ownerName: [
            {
              required: true,
              message: '请输入车主姓名',
              trigger: 'blur'
            }
          ],
          estimateDeliveryTime: [
            {
              required: true,
              message: '请输入交车时间',
              trigger: 'change'
            }
          ],
          consultantId: [
            {
              required: true,
              message: '请选择顾问',
              trigger: 'change'
            }
          ],
          insuranceCompanyId: [
            {
              required: true,
              message: '请选择保险公司',
              trigger: 'change'
            }
          ],
          outsideReworkReasonId: [
            {
              required: true,
              message: '请选择外返原因',
              trigger: 'change'
            }
          ]
        },
            workCop: this.work,
            carPanel: false,
            value1: 0,
            option1: [], // 付款方式
            value2: 0,
            option2: [], // 保险公司
            value3: 0,
            option3: [], // 服务顾问
            showDateTimePicker: false, // 时间控件是否显示
            editEstimateDeliveryTime: null, // 选择的时间
            urgentradio: '0', // 是否加急
            outsideradio: '0', // 是否外返
            value4: 0,
            option4: [] // 外返原因
        }
      },
      created () {
        // 测试门店便利
        this.editEstimateDeliveryTime = this.work.enterTime.format('yyyy-MM-dd hh:mm')
        this.work.estimateDeliveryTime = this.work.enterTime
        // 获取付款方式
        var arr1 = this.$store.state.data.PAY_METHOD
        for (var val1 of arr1) {
            if (val1.code === this.work.payMethodCode) {
                this.value1 = val1.id
            }
            this.option1.push(
                {
                    text: val1.name,
                    value: val1.code
                }
            )
        }
        // 获取保险公司
        var arr2 = this.$store.state.data.INSURANCE_COMPANY
        this.option2.push({ text: '请选择', value: null })
        this.value2 = -1
        for (var val2 of arr2) {
            this.option2.push(
                {
                    text: val2.name,
                    value: val2.id
                }
            )
        }
        // 获取服务顾问
        var arr3 = this.$store.state.data.ConsultantsOfShop
        this.option3.push({ text: '请选择', value: null })
        this.value3 = -1
        for (var val3 of arr3) {
            if (this.$store.state.user.level === 'SHOP') {
                if (val3.id === this.$store.state.shop.id) {
                    for (var v3 of val3.consultants) {
                        this.option3.push(
                            {
                                text: v3.name,
                                value: v3.id
                            }
                        )
                    }
                }
            } else {
                for (var v4 of val3.consultants) {
                    this.option3.push(
                        {
                            text: v4.name,
                            value: v4.id
                        }
                    )
                }
            }
        }
        // 获取外返原因
        var arr4 = this.$store.state.data.OUTSIDE_REWORK_REASON
        this.option4.push({ text: '请选择', value: null })
        this.value4 = -1
        for (var val4 of arr4) {
            this.option4.push(
                {
                    text: val4.name,
                    value: val4.id
                }
            )
        }
        this.work.carNo = this.$store.state.shop.carNoPrefix
      },
      methods: {
        openDateTimePicker () {
            this.showDateTimePicker = true
        },
        confirm () {
            this.work.estimateDeliveryTime = this.editEstimateDeliveryTime
            this.editEstimateDeliveryTime = new Date(this.editEstimateDeliveryTime).format('yyyy-MM-dd hh:mm')
            this.showDateTimePicker = false
        },
        cancel () {
            this.showDateTimePicker = false
        },
        changeCarNo () {
        const carNo = this.work.carNo.toUpperCase()
        if (!isCarNo(carNo)) return
        customerByCarNo(carNo).then(response => {
          const customer = response.data
          if (!customer) return
          this.work.ownerName = customer.name
          this.work.phone = customer.cellphone
          this.work.brandModel = customer.brandModel
          this.work.color = customer.color
        })
      },
      changeOwnerCellphone () {
        const phone = this.work.phone
        if (!phone) return
        customerByCellphone(phone).then(response => {
          const customer = response.data
          if (!customer) return
          this.work.ownerName = customer.name
          this.work.carNo = customer.carNo
          this.work.brandModel = customer.brandModel
          this.work.color = customer.color
        })
      }
      },
      computed: {
        isConsultant () {
            return checkHasPosition('CONSULTANT_PO')
        },
        minDate () {
            return new Date()
        },
        maxDate () {
            const date = new Date()
            date.setTime(date.getTime() + 180 * 24 * 60 * 60 * 1000)
            return date
        },
        repairDays () {
            if (!this.work.estimateDeliveryTime) return '?'
            return Math.floor(new Date(this.work.estimateDeliveryTime) / (1000 * 60 * 60 * 24)) - this.work.enterTime.getLocalDays() + 1
        },
        isInsurancePay () {
            return this.work.payMethodCode === 'insurance_company'
        }
      }
    }
  </script>

  <style lang="scss" scoped>
    .basicInfo{
        background-color:white;
        width: 96%;
        margin: 0px auto;
        border: 1px solid white;
        border-radius: 10px;
        padding-bottom: 10px;
}
    .title{
        font-size: 20px;
    }
    .formList{
        display: flex;
        justify-content: space-around;
        margin-top: 10px;
    }
    .formOne{
        display: flex;
        align-items: center;
    }
    .OneText{
        width: 60px;
    }
    .inputEl{
        width: 110px;
    }
    /deep/ .van-dropdown-menu__bar{
        width: 98px;
        height: 18px;
        border: 1px solid #DCDFE6;
        border-radius: 5px;
        padding: 0 5px;
    }
    /deep/ .van-ellipsis{
        font-size: 12px;
    }
    /deep/ .van-dropdown-item--down{
        width: 96%;
        margin: 0px auto;
    }
    /deep/ .el-input__inner{
        height: 20px;
        line-height: 20px;
        margin-top: 6px;
        padding: 0px 5px;
    }
    /deep/ .el-input__icon{
        line-height: 20px;
    }
    /deep/ .el-form-item__label{
        font-size: 12px;
        padding: 0 5px 0 0
    }
    /deep/ .el-form-item__content{
        font-size: 12px;
    }
    /deep/ .el-form-item__error{//不显示验证未通过的消息提示
        display: none;
    }
    /deep/ .el-form-item--small.el-form-item{//不显示提示后缩短间距
        margin-bottom: 5px;
    }
  </style>
